// @flow
import {Form} from './form';

export class FormBuklet
{
    #app;
    #appInstance = null;
    #productId = null;
    #productName = '';
    #downloadContext = '';

    constructor(rootNode, productId, options = {}): void
    {
        this.rootNode = document.querySelector(rootNode);
        this.#productId = productId;
        this.#productName = options.productName || '';
        this.#downloadContext = options.downloadContext === 'engine' ? 'engine' : '';
    }

    setProductId(productId, productName = ''): boolean
    {
        const form = this.#appInstance && this.#appInstance.$refs.form;
        if (form && form.spinner) return false;
        this.#productId = productId;
        this.#productName = productName;
        if (this.#appInstance) {
            this.#appInstance.productId = productId;
            this.#appInstance.productName = productName;
        }
        return true;
    }

    start(): void
    {
        if (!this.rootNode || this.#appInstance) return;
        this.#app = BX.Vue3.BitrixVue.createApp({
            components: {Form},
            template: `<Form ref="form" :product-id="productId" :product-name="productName" :download-context="downloadContext"/>`,
            data: () => ({
                productId: this.#productId,
                productName: this.#productName,
                downloadContext: this.#downloadContext,
            }),
        });
        this.#appInstance = this.#app.mount(this.rootNode);
    }
}
